import Homepage from './Homepage'
import { LAYOUT_SECTIONS, WIDGETS } from '../constants'
import { hot } from 'react-hot-loader'

class Atlas extends Homepage {
  getDesktopWidgetsLayout () {
    const layout = super.getDesktopWidgetsLayout()
    layout[LAYOUT_SECTIONS.OUTSIDE_CONTENT] = [
      WIDGETS.HOMEPAGE.NATIVE_APP_PROMO
    ]

    return layout
  }

  getTabletWidgetsLayout () {
    const layout = super.getTabletWidgetsLayout()
    layout[LAYOUT_SECTIONS.OUTSIDE_CONTENT] = [
      WIDGETS.HOMEPAGE.NATIVE_APP_PROMO
    ]

    return layout
  }

  getMobileWidgetsLayout () {
    const layout = super.getMobileWidgetsLayout()
    layout[LAYOUT_SECTIONS.OUTSIDE_CONTENT] = [
      WIDGETS.HOMEPAGE.NATIVE_APP_PROMO,
      WIDGETS.COMMON.SMART_ADVERT_4
    ]

    return layout
  }
}

export default hot(module)(Atlas)
